import React, { FC } from 'react';
import {
    NavigationMenuItem,
    DropdownMenuItemProps,
} from '../../models/NavigationMenuItem';
import { Box, styled } from '@mui/material';
import { NavigationItemContent } from './NavigationItemContent';

const HoveredContent = styled(Box)(() => ({
    backgroundColor: 'white',
    position: 'absolute',
    top: '99%',
    left: '0',
    width: '100%',
    zIndex: '10',
    overflowX: 'hidden',
    overflowY: 'auto',
    maxHeight: '70vh',
    textAlign: 'left',
    opacity: 0,
    visibility: 'hidden',
    boxShadow: '0 6px 27px #0003',
    transition: 'all 200ms ease-in',

    '&.open': {
        // display: 'flex',
        opacity: 1,
        visibility: 'visible',
    },
}));

const MegamenuContainer = styled(Box)(() => ({
    display: 'flex',
    padding: '20px',
    gap: '5px',
    width: '100%',
    flexWrap: 'wrap',
    '> *': {
        flex: '0 1 16%',
    },
}));

export const Megamenu: FC<DropdownMenuItemProps> = (props) => {
    const menuItems = props.menuItem;
    const anchorEl = props.anchorEl;
    const open = Boolean(anchorEl);

    const handleClose = () => {
        props.clickHandler();
    };

    return (
        <HoveredContent className={open ? 'open' : ''}>
            <MegamenuContainer>
                {menuItems.map((item: NavigationMenuItem) => (
                    <Box key={item.id}>
                        <NavigationItemContent
                            menuItem={item}
                            clickHandler={handleClose}
                        />
                    </Box>
                ))}
            </MegamenuContainer>
        </HoveredContent>
    );
};
